import Select from '@mui/material/Select';
import { alpha, styled } from '@mui/material/styles';

/** Select that tints itself with the brand color while a non-default filter is applied. */
export const FilterSelect = styled(Select, {
  shouldForwardProp: prop => prop !== 'active',
})<{ active?: boolean }>(({ theme, active }) => ({
  '& .MuiSelect-select': { typography: 'body2' },
  ...(active && {
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
    '&:hover': { backgroundColor: alpha(theme.palette.primary.main, 0.12) },
  }),
}));
